import { render, staticRenderFns } from "./RedirectPage.vue?vue&type=template&id=6c978b58"
import script from "./RedirectPage.ts?vue&type=script&lang=ts&external"
export * from "./RedirectPage.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports